//javascript,react libraries
import { useEffect, useContext, useState } from "react";
//app data
import { UserContext } from "../../../model/contexts/user.context";

//components
import NavBar from "../../components/NavBar/NavBar";
import SideBar from "../../components/SideBar/SideBar";
import TaskDashboard from "../../components/TaskDashboard/TaskDashboard";

//styling
import "./TaskDashboardPage.scss";
import SignIn from "../../components/SignIn/SignIn";

const TaskDashboardPage = () => {
  const { currentUser, setCurrentUser } = useContext(UserContext);

  return (
    <div className="dashboard-container-context">
      <TaskDashboard />
    </div>
  );
};

export default TaskDashboardPage;

//include the form modal when project is selected using edit button**
//prioritize by number of tasks, recently updated, date created, project importance, etc.
